import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import type { NavigateOptions, To } from "react-router-dom";
import { omit, pick } from "lodash-es";
import appStore from '@/stores';

interface NavigateSettings extends NavigateOptions {
  /** 是否退出当前页 */
  close?: boolean;
  /** 是否阻止跳转 */
  block?: boolean;
  /** 是否强制刷新页面 */
  refresh?: boolean;
  target?: '_blank';
};
export const PageNavigateStateName = 'PageNavigateStateName';
const PageNavigatePropsName = ['close', 'block','refresh', 'target'];

export default function usePageNavigate() {
  const navigate = useNavigate();

  const pageNavigate = useCallback((to: To, options?: NavigateSettings) => {
    const customProps = pick(options, PageNavigatePropsName);
    const navigateOptions = omit(options, PageNavigatePropsName) || {};

    navigateOptions.state = {
      ...navigateOptions.state,
      [PageNavigateStateName]: customProps,
    };


    if (options?.refresh) {
      if (window.__MICRO_APP_ENVIRONMENT__) {
        const targetUrl = `${appStore.config?.edsUrl}${to}`;
        // close: true 时通过 EDS PageTabTool 关闭当前页签并跳转（与 EDS closeCurrentPage 对齐）
        if (options?.close) {
          const PageTabTool = (window as any)?.rawWindow?.top?.PageTabTool;
          if (PageTabTool?.closeCurrentPage) {
            PageTabTool.closeCurrentPage({ href: targetUrl });
            return true;
          }
        }
        window.location.href = targetUrl;
      } else {
        window.location.href = to.toString();
      }
      return true;
    }
    navigate(to, navigateOptions);
  }, [navigate]);
  return pageNavigate;
}
